import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Star, Quote, Calendar, User, Heart, Sparkles, Filter } from 'lucide-react';

const Reviews = () => {
  const [filter, setFilter] = useState('all');
  const [animateReviews, setAnimateReviews] = useState(Array(15).fill(false));

  // Dummy reviews data
  const reviews = [
    {
      id: 1,
      name: "Ali khan",
      event: "Wedding Reception",
      date: "January 15, 2024",
      rating: 5,
      comment: "Jashn made our wedding absolutely magical! Every detail was perfect. They understood our vision and executed it flawlessly. The decor, food, and coordination were beyond our expectations.",
      avatarColor: "from-pink-400 to-rose-400",
      initials: "PS"
    },
    {
      id: 2,
      name: "Uzair naseer",
      event: "Corporate Retreat",
      date: "December 5, 2023",
      rating: 5,
      comment: "Best event planners in town! Our team-building trip was organized so well. Everything from transportation to activities was seamless. Highly recommend Jashn for corporate events!",
      avatarColor: "from-blue-400 to-cyan-400",
      initials: "RV"
    },
    {
      id: 3,
      name: "Soban Ahmed",
      event: "Baby Shower",
      date: "November 22, 2023",
      rating: 5,
      comment: "What a beautiful celebration! The team at Jashn created such a warm and joyful atmosphere. The theme, decorations, and food were perfect. All our guests were impressed!",
      avatarColor: "from-purple-400 to-pink-400",
      initials: "AP"
    },
    {
      id: 4,
      name: "Sara jaswal",
      event: "Birthday Party",
      date: "October 30, 2023",
      rating: 4,
      comment: "Excellent service! My daughter's 10th birthday party was a huge success. The games, entertainment, and cake were amazing. Will definitely use Jashn again!",
      avatarColor: "from-yellow-400 to-orange-400",
      initials: "VS"
    },
    {
      id: 5,
      name: "Kashif Ali",
      event: "Engagement Ceremony",
      date: "October 15, 2023",
      rating: 5,
      comment: "Absolutely stunning! The floral arrangements and lighting were breathtaking. Jashn team was professional, creative, and attentive to every detail. Worth every penny!",
      avatarColor: "from-green-400 to-emerald-400",
      initials: "MK"
    },
    {
      id: 6,
      name: "Obaid Ali",
      event: "Anniversary Party",
      date: "September 8, 2023",
      rating: 5,
      comment: "25 years never looked so good! Jashn created the most romantic anniversary celebration. The surprise element for my wife was executed perfectly. Thank you!",
      avatarColor: "from-red-400 to-orange-400",
      initials: "AR"
    },
    {
      id: 7,
      name: "Saleem Nawaz",
      event: "Baby's First Birthday",
      date: "August 20, 2023",
      rating: 5,
      comment: "Pure magic! The theme was 'Under the Sea' and Jashn brought it to life. The decorations were incredible, and the photographer captured beautiful moments. Highly recommended!",
      avatarColor: "from-indigo-400 to-blue-400",
      initials: "SN"
    },
    {
      id: 8,
      name: "Emaan Ali",
      event: "Product Launch",
      date: "July 12, 2023",
      rating: 5,
      comment: "Professional and creative! Our product launch was a massive success thanks to Jashn. The setup, AV equipment, and catering were flawless. Great attention to detail!",
      avatarColor: "from-teal-400 to-cyan-400",
      initials: "RM"
    },
    {
      id: 9,
      name: "Maryam masood",
      event: "Wedding Ceremony",
      date: "June 5, 2023",
      rating: 5,
      comment: "Dream come true! Jashn handled our destination wedding perfectly. From hotel bookings to the actual ceremony, everything was organized seamlessly. Thank you for the memories!",
      avatarColor: "from-pink-300 to-rose-300",
      initials: "PM"
    },
    {
      id: 10,
      name: "masud tariq",
      event: "Movie Premiere Party",
      date: "May 18, 2023",
      rating: 5,
      comment: "Spectacular event! The red carpet setup, lighting, and overall ambiance were Hollywood-level. Jashn knows how to throw a star-studded party. Will work with them again!",
      avatarColor: "from-yellow-500 to-amber-500",
      initials: "KJ"
    },
    {
      id: 11,
      name: "Hina Gul",
      event: "Graduation Party",
      date: "April 25, 2023",
      rating: 4,
      comment: "Wonderful experience! The graduation party for my son was perfectly organized. The food, music, and decorations were great. Jashn team was very responsive and professional.",
      avatarColor: "from-purple-300 to-violet-300",
      initials: "NG"
    },
    {
      id: 12,
      name: "Aamir Raza",
      event: "Farewell Party",
      date: "March 30, 2023",
      rating: 5,
      comment: "Emotional and beautiful! Jashn created a perfect farewell for our retiring CEO. The tribute video, speeches, and dinner were all beautifully coordinated. Exceptional service!",
      avatarColor: "from-blue-300 to-sky-300",
      initials: "AR"
    },
    {
      id: 13,
      name: "Irfan Durrani",
      event: "House Warming",
      date: "February 14, 2023",
      rating: 5,
      comment: "Made our new house a home! The house warming ceremony was traditional yet modern. Jashn balanced both perfectly. All our relatives loved the arrangements. Thank you!",
      avatarColor: "from-rose-400 to-pink-400",
      initials: "ID"
    },
    {
      id: 14,
      name: "Rida Khan",
      event: "Charity Gala",
      date: "January 28, 2023",
      rating: 5,
      comment: "Raised record funds! The charity event was elegant and well-organized. Jashn handled everything from guest list to auction setup. Professional and compassionate team!",
      avatarColor: "from-emerald-400 to-green-400",
      initials: "RK"
    },
    {
      id: 15,
      name: "Tariq Mehmood",
      event: "Destination Wedding",
      date: "December 20, 2022",
      rating: 5,
      comment: "Beyond expectations! Our Goa destination wedding was a fairytale. Jashn managed everything from flights to the beach ceremony. Stress-free and absolutely beautiful!",
      avatarColor: "from-cyan-400 to-blue-400",
      initials: "TM"
    }
  ];

  // Filter reviews based on rating
  const filteredReviews = filter === 'all' 
    ? reviews 
    : filter === '5-stars' 
      ? reviews.filter(r => r.rating === 5)
      : reviews.filter(r => r.rating === 4);

  // Animation for reviews on scroll
  useEffect(() => {
    const handleScroll = () => {
      const reviewElements = document.querySelectorAll('.review-card');
      reviewElements.forEach((element, index) => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          setTimeout(() => {
            setAnimateReviews(prev => {
              const newState = [...prev];
              newState[index] = true;
              return newState;
            });
          }, index * 100);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger on initial load

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Render stars based on rating
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`h-5 w-5 ${
          i < rating
            ? 'fill-yellow-400 text-yellow-400'
            : 'fill-gray-200 text-gray-200'
        }`}
      />
    ));
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 px-4 overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-yellow-200 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-30"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-200 rounded-full translate-x-1/3 translate-y-1/3 opacity-30"></div>
        
        <div className="container mx-auto relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center p-4 bg-gradient-to-r from-yellow-100 to-pink-100 rounded-2xl mb-6">
              <Star className="h-12 w-12 text-yellow-500 animate-pulse" />
              <Sparkles className="h-10 w-10 text-pink-500 -ml-4 animate-pulse" style={{ animationDelay: '0.5s' }} />
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-yellow-500 to-pink-500 bg-clip-text text-transparent">
              Customer Love Stories
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              See what our happy customers are saying about their magical experiences with Jashn
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-yellow-600 mb-2">4.9/5</div>
              <div className="flex mb-2">
                {renderStars(5)}
              </div>
              <p className="text-gray-600">Average Rating</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-pink-600 mb-2">500+</div>
              <p className="text-gray-600">Events Planned</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-yellow-600 mb-2">98%</div>
              <p className="text-gray-600">Customer Satisfaction</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-pink-600 mb-2">15+</div>
              <p className="text-gray-600">Cities Across India</p>
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <button
              onClick={() => setFilter('all')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center space-x-2 ${
                filter === 'all'
                  ? 'bg-gradient-to-r from-yellow-400 to-pink-400 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-yellow-50'
              }`}
            >
              <Filter className="h-5 w-5" />
              <span>All Reviews</span>
            </button>
            <button
              onClick={() => setFilter('5-stars')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center space-x-2 ${
                filter === '5-stars'
                  ? 'bg-gradient-to-r from-yellow-400 to-pink-400 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-yellow-50'
              }`}
            >
              <Star className="h-5 w-5 fill-yellow-400 text-yellow-400" />
              <span>5 Star Reviews</span>
              <span className="px-2 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm">
                {reviews.filter(r => r.rating === 5).length}
              </span>
            </button>
            <button
              onClick={() => setFilter('4-stars')}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center space-x-2 ${
                filter === '4-stars'
                  ? 'bg-gradient-to-r from-yellow-400 to-pink-400 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-yellow-50'
              }`}
            >
              <Star className="h-5 w-5 fill-yellow-400 text-yellow-400" />
              <span>4 Star Reviews</span>
              <span className="px-2 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm">
                {reviews.filter(r => r.rating === 4).length}
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="pb-20 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredReviews.map((review, index) => (
              <div
                key={review.id}
                className={`review-card transform transition-all duration-700 ${
                  animateReviews[index]
                    ? 'translate-y-0 opacity-100'
                    : 'translate-y-10 opacity-0'
                }`}
                style={{ transitionDelay: `${(index % 6) * 100}ms` }}
              >
                <div className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 h-full border border-yellow-100">
                  {/* Review Header */}
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className={`h-14 w-14 rounded-full bg-gradient-to-r ${review.avatarColor} flex items-center justify-center text-white font-bold text-lg`}>
                        {review.initials}
                      </div>
                      <div>
                        <h3 className="font-bold text-lg text-gray-800">{review.name}</h3>
                        <div className="flex items-center space-x-1">
                          {renderStars(review.rating)}
                          <span className="text-gray-500 text-sm ml-2">{review.rating}.0</span>
                        </div>
                      </div>
                    </div>
                    <Quote className="h-8 w-8 text-yellow-300" />
                  </div>

                  {/* Review Content */}
                  <div className="mb-6">
                    <p className="text-gray-600 italic">"{review.comment}"</p>
                  </div>

                  {/* Review Footer */}
                  <div className="pt-4 border-t border-yellow-100">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2 text-gray-500">
                        <Calendar className="h-4 w-4" />
                        <span className="text-sm">{review.date}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <span className="px-3 py-1 bg-gradient-to-r from-yellow-50 to-pink-50 text-yellow-700 rounded-full text-sm font-medium">
                          {review.event}
                        </span>
                        <button className="p-2 hover:bg-yellow-50 rounded-full transition-colors">
                          <Heart className="h-4 w-4 text-pink-400 hover:text-pink-500" />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Decorative Elements */}
                  <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-yellow-100 to-pink-100 rounded-bl-2xl rounded-tr-2xl -m-1 opacity-50"></div>
                  <div className="absolute bottom-0 left-0 w-8 h-8 bg-gradient-to-tr from-yellow-200 to-pink-200 rounded-tr-2xl -m-1 opacity-30"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center mt-16">
            <div className="inline-block p-8 bg-gradient-to-r from-yellow-50 to-pink-50 rounded-3xl border border-yellow-200 max-w-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Ready to Create Your Own Magical Experience?
              </h3>
              <p className="text-gray-600 mb-6">
                Join our family of happy customers and let us make your event unforgettable!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="px-8 py-3 bg-gradient-to-r from-yellow-400 to-pink-400 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-yellow-200 transform hover:-translate-y-1 transition-all duration-300">
                  Book Your Event Now
                </button>
                <button className="px-8 py-3 bg-white text-gray-700 font-semibold rounded-full hover:bg-yellow-50 border border-yellow-200 transition-all duration-300">
                  Write a Review
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Reviews;